import React from "react";

import estados from "../../services/estados";
import api from "../../services/api";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import { store } from "react-notifications-component";
import GenericUpper from "../../components/generic-upper";
import { DevolucaoAddContainer } from "./styles";
import { Container } from "react-grid-system";
import Input from "../../components/input/input_v2";
import Select from "../../components/select/select_v2";
import Button from "../../components/button/button_v2";
import Interruptor from "../../components/interruptor";
import buscaCep from "../../services/buscaCep";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";

import * as S from "./styles";

class AddDevolucao extends React.Component {

    state = {
        filial: null,
        nome: "",
        estado: "",
        cep: "",
        telefone: "",
        celular: "",
        responsavel: "",
        cnpj: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        OpStatus: [{ value: 1, label: "Ativo" }, { value: 0, label: "Inativo" }],
        status: 1,
        filiais: [],
        loading: false,

        erroFilial: false,
        erroFilialMsg: '',

        erroBairro: false,
        erroBairroMsg: '',

        erroCep: false,
        erroCepMsg: '',

        erroCidade: false,
        erroCidadeMsg: '',

        erroEndereco: false,
        erroEnderecoMsg: '',

        erroEstado: false,
        erroEstadoMsg: '',

        erroNome: false,
        erroNomeMsg: '',

        erroCnpj: false,
        erroCnpjMsg: '',

        erroNumero: false,
        erroNumeroMsg: '',

        erroStatus: false,
        erroStatusMsg: '',

        loadingCep: false,

        useInpev: true,
        inpevLocations: [],
        loadingInpev: false,
        selectedInpevLocation: null,
    };

    // mapeia nome do campo -> [flagErro, msgErro] no seu state
    fieldMap = {
        agro_subsidiary_id: ["erroFilial", "erroFilialMsg"],
        filial: ["erroFilial", "erroFilialMsg"], // fallback
        nome: ["erroNome", "erroNomeMsg"],
        cnpj: ["erroCnpj", "erroCnpjMsg"],
        cep: ["erroCep", "erroCepMsg"],
        endereco: ["erroEndereco", "erroEnderecoMsg"],
        bairro: ["erroBairro", "erroBairroMsg"],
        numero: ["erroNumero", "erroNumeroMsg"],
        cidade: ["erroCidade", "erroCidadeMsg"],
        estado: ["erroEstado", "erroEstadoMsg"],
        status: ["erroStatus", "erroStatusMsg"],
    };

    // validação local antes de bater na API
    validate = async () => {
        const {
            nome, cnpj, cep, endereco, bairro, numero, cidade, estado, filial
        } = this.state;

        const required = {
            nome, cep, endereco, bairro, numero, cidade, estado,
            agro_subsidiary_id: filial?.value || filial, // id da filial
        };

        let ok = true;
        const next = {};

        Object.entries(required).forEach(([field, value]) => {
            const v = (value ?? "").toString().trim();
            const map = this.fieldMap[field];
            if (!map) return;

            if (!v) {
                ok = false;
                next[map[0]] = true;
                next[map[1]] = "Campo obrigatório.";
            } else {
                next[map[0]] = false;
                next[map[1]] = "";
            }
        });

        const hasCnpj = String(cnpj || "").replace(/\D/g, "").length > 0;
        if (hasCnpj) {
            const resultadoCnpj = await this.isValidCnpj(cnpj);
            if (!resultadoCnpj.valido) {
                ok = false;
                next.erroCnpj = true;
                next.erroCnpjMsg = resultadoCnpj.erro || "Informe um CNPJ válido.";
            }
        }

        this.setState(next);
        return ok;
    };

    // submit do formulário (previne reload)
    handleSubmit = async (e) => {
        e.preventDefault();
        if (!(await this.validate())) {
            store.addNotification({
                title: "Atenção",
                message: "Preencha os campos obrigatórios.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true },
            });
            return;
        }
        this.handlePost();
    };

    formatCnpj = (valor = "") => {
        let value = String(valor).replace(/\D/g, "");
        value = value.slice(0, 14);
        value = value.replace(/^(\d{2})(\d)/, "$1.$2");
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
        value = value.replace(/(\d{4})(\d)/, "$1-$2");
        return value;
    };

    // Consulta o microserviço de validação (com fallback local se ele não
    // responder). Retorna { valido, erro } — cnpj fora do padrão nem chega a
    // consultar o serviço.
    isValidCnpj = async (valor = "") => {
        const cnpj = String(valor).replace(/\D/g, "");
        if (!cnpj || cnpj.length !== 14) return { valido: false, erro: null };
        return validadorCpfCnpj(cnpj);
    };

    validateCnpj = (valor) => {
        this.setState({
            cnpj: this.formatCnpj(valor),
            erroCnpj: false,
            erroCnpjMsg: "",
        });
    };

    validaCNPJ = async (valor) => {
        const hasValue = String(valor || "").replace(/\D/g, "").length > 0;
        if (!hasValue) {
            this.setState({ erroCnpj: false, erroCnpjMsg: "" });
            return;
        }

        const resultado = await this.isValidCnpj(valor);
        this.setState({
            erroCnpj: !resultado.valido,
            erroCnpjMsg: resultado.valido ? "" : (resultado.erro || "Informe um CNPJ válido."),
        });
    };


    componentDidMount() {
        if (this.props.isModal != true) {
            window.scrollTo(0, 0);
        }
        this.getFiliais();
        if (this.state.useInpev && this.state.inpevLocations.length === 0) {
            this.getInpevLocations();
        }
    };

    handlePost = async e => {

        this.setState({ loading: true });

        const filialId =
            this.state.filial && typeof this.state.filial === "object"
                ? this.state.filial.value
                : (this.state.filial || null);


        const {
            nome,
            responsavel,
            cnpj,
            telefone,
            celular,
            estado,
            numero,
            complemento,
            cep,
            endereco,
            bairro,
            cidade,
            filial,
            status
        } = this.state;

        const payload = {
            nome,
            estado,
            endereco,
            numero,
            complemento,
            bairro,
            cidade,
            telefone,
            celular,
            responsavel,
            cnpj,
            cep,
            agro_subsidiary_id: filialId,
            status
        };

        try {
            const response = await api.post("/devolucoes", payload);

            if (response.status === 201) {
                this.setState({ loading: false });

                if (this.props.isModal === true) {
                    this.props.update();
                } else {
                    this.props.history.push("/devolucoes");
                }
                store.addNotification({
                    title: "Sucesso!",
                    message: "A devolução foi cadastrada corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        } catch (err) {
            this.setState({ loading: false });

            // zera flags antes de aplicar novos erros
            this.setState({
                erroFilial: false, erroFilialMsg: '',
                erroBairro: false, erroBairroMsg: '',
                erroCep: false, erroCepMsg: '',
                erroCidade: false, erroCidadeMsg: '',
                erroEndereco: false, erroEnderecoMsg: '',
                erroEstado: false, erroEstadoMsg: '',
                erroNome: false, erroNomeMsg: '',
                erroCnpj: false, erroCnpjMsg: '',
                erroNumero: false, erroNumeroMsg: '',
                erroStatus: false, erroStatusMsg: '',
            });

            const errorsObj = err?.response?.data?.errors;   // { campo: msg/obj }
            const messagesArr = err?.response?.data?.message;  // ["campo should not be empty", ...]

            const next = {};

            if (errorsObj && typeof errorsObj === "object") {
                Object.keys(errorsObj).forEach((field) => {
                    const pair = this.fieldMap[field];
                    if (!pair) return;

                    const [flagKey, msgKey] = pair;
                    const val = errorsObj[field];
                    const msg = typeof val === "string" ? val : (val?._empty || "Campo obrigatório.");

                    next[flagKey] = true;
                    next[msgKey] = msg;
                });
            } else if (Array.isArray(messagesArr)) {
                messagesArr.forEach((m) => {
                    const match = String(m).match(/^([a-zA-Z_]+)/);
                    if (!match) return;
                    let field = match[1];
                    if (field === "filial") field = "agro_subsidiary_id"; // normaliza
                    const pair = this.fieldMap[field];
                    if (!pair) return;
                    const [flagKey, msgKey] = pair;
                    next[flagKey] = true;
                    next[msgKey] = "Campo obrigatório.";
                });
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(err, "ERRO-652 Erro ao salvar - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 5000, onScreen: true }
                });
                return;
            }

            this.setState(next);

            store.addNotification({
                title: "Erro!",
                message: "Verifique os campos em vermelho",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 5000, onScreen: true }
            });
        }
    };

    cangeCep = (e) => {
        this.setState({ cep: e, erroCep: false });
    }

    fetchCep = async () => {
        this.setState({ loadingCep: true });
        let separaCep = this.state.cep;

        try {
            const cep = await buscaCep(separaCep);
            const { logradouro, bairro, localidade, uf } = cep;

            this.setState({
                endereco: logradouro,
                erroEndereco: false,

                bairro,
                erroBairro: false,

                cidade: localidade,
                erroCidade: false,

                estado: uf,
                erroEstado: false,

                loadingCep: false
            });


        } catch (err) {

            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
            this.setState({ loadingCep: false, erroCep: true, erroCepMsg: err.message });
        }
    };

    getFiliais = async () => {
        try {
            const response = await api.get("/filiais");
            const filiais = response.data.data;

            if (filiais.length) {
                const formatFiliais = filiais.map(f => {
                    let format = {
                        value: f.id,
                        label: f.nome_fantasia
                    };
                    return format;
                });


                if (filiais && filiais.length > 0) {
                    this.setState({ filiais: formatFiliais });
                } else {
                    this.setState({ filiais: formatFiliais });

                }

            } else {
                const formatFiliais = [{ value: filiais.id, label: filiais.nome_fantasia }];
                this.setState({ filiais: formatFiliais });
            }




        } catch (e) {
            this.setState({ loading: false });
        }
    };

    handleToggleInpev = (value) => {
        this.setState({ useInpev: value });
        if (value) {
            if (this.state.inpevLocations.length === 0) {
                this.getInpevLocations();
            }
        } else {
            this.setState({
                selectedInpevLocation: null,
                nome: "",
                responsavel: "",
                telefone: "",
                celular: "",
                cep: "",
                endereco: "",
                numero: "",
                complemento: "",
                bairro: "",
                cidade: "",
                estado: "",
            });
        }
    }

    getInpevLocations = async () => {
        this.setState({ loadingInpev: true });
        try {
            const response = await api.get('/devolucoes/inpev');
            const options = response.data.data.map(item => ({
                value: item.id,
                label: item.nome,
                ...item
            }));
            this.setState({ inpevLocations: options, loadingInpev: false });
        } catch (e) {
            this.setState({ loadingInpev: false });
            store.addNotification({
                title: "Erro",
                message: identifyErrorMenssage(
                    e,
                    "ERRO-653 Erro ao buscar locais de devolucao do INPEV - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 5000, onScreen: true }
            });
        }
    }

    handleInpevSelect = (option) => {
        if (!option || option.value === "" || option.value === null || option.value === undefined) {
            this.setState({
                selectedInpevLocation: null,
                nome: "",
                responsavel: "",
                telefone: "",
                celular: "",
                cep: "",
                endereco: "",
                numero: "",
                complemento: "",
                bairro: "",
                cidade: "",
                estado: "",
                erroNome: false,
                erroEndereco: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroEstado: false,
                erroCep: false,
            });
            return;
        }

        const estadoObj = estados.find((e) => e.value === option.estado);
        const estadoValue = estadoObj ? estadoObj.value : option.estado;

        this.setState({
            selectedInpevLocation: option,
            nome: option.label,
            responsavel: option.responsavel || "",
            telefone: option.telefone || "",
            celular: option.celular || "",
            cep: option.cep || "",
            endereco: option.endereco || "",
            numero: option.numero || "",
            complemento: option.complemento || "",
            bairro: option.bairro || "",
            cidade: option.cidade || "",
            estado: estadoValue || "",

            erroNome: false,
            erroEndereco: false,
            erroNumero: false,
            erroBairro: false,
            erroCidade: false,
            erroEstado: false,
            erroCep: false,
        });
    }

    render() {
        const {
            nome,
            estado,
            endereco,
            numero,
            complemento,
            bairro,
            cidade,
            cep,
            responsavel,
            cnpj,
            telefone,
            celular,
        } = this.state;

        return (
            <>

                {this.props.isModal === true ? (
                    <h4 style={{ textAlign: 'center' }}>Local de devolução</h4>
                ) : (
                    <GenericUpper
                        title="Cadastro de Devolução"
                        subtitle="Cadastre um local de devolução"
                        help={true}
                        text={"Dúvidas para cadastrar um local de devolução?"}
                        toSearch={'https://agroreceita.com.br/como-cadastrar-locais-de-devolucao/'}
                        textToSearch={'Clique aqui e acesse o tutorial!'}
                    ></GenericUpper>
                )}

                <DevolucaoAddContainer {...this.props}>
                    <Container style={{ paddingLeft: this.props.isModal ? '0px' : '15px', paddingRight: this.props.isModal ? '0px' : '15px' }}>
                        <form onSubmit={this.handleSubmit}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '40px', justifyContent: 'center' }}>
                                <Interruptor
                                    value={this.state.useInpev}
                                    onChange={this.handleToggleInpev}
                                />
                                <span style={{ marginLeft: '10px' }}>
                                    Utilizar local de devolução                                    <a
                                        href="https://www.sistemacampolimpo.org.br/logistica-reversa/unidades-recebimento/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        cadastrado no INPEV
                                    </a>
                                    <br />

                                </span>
                            </div>

                            {this.state.useInpev ? (
                                <S.ContainerInput>
                                    <Select
                                        marginBottom="36px"
                                        name="nome"
                                        label="Nome"
                                        id="nome"
                                        value={this.state.selectedInpevLocation}
                                        onChange={this.handleInpevSelect}
                                        options={this.state.inpevLocations}
                                        loading={this.state.loadingInpev}
                                        isSearch={true}
                                        labelWithAsterisk
                                        erro={this.state.erroNome}
                                        messageErro={this.state.erroNomeMsg}
                                        multilineOptions={true}
                                    />
                                </S.ContainerInput>
                            ) : (
                                <Input
                                    marginBottom="4px"
                                    name="nome"
                                    type="text"
                                    label="Nome"
                                    value={nome}
                                    id="nome"
                                    onChange={e => this.setState({ nome: e, erroNome: false })}
                                    erro={this.state.erroNome}
                                    messageErro={this.state.erroNomeMsg}
                                    labelWithAsterisk
                                />
                            )}

                            <Input
                                marginBottom="4px"
                                name="cnpj"
                                label='CNPJ'
                                id="id_cnpj"
                                value={cnpj}
                                onChange={e => this.validateCnpj(e)}
                                onBlur={e => this.validaCNPJ(e.target.value)}
                                inputmode="numeric"
                                erro={this.state.erroCnpj}
                                messageErro={this.state.erroCnpjMsg}
                            />

                            <Input
                                marginBottom="4px"
                                name="responsavel"
                                type="text"
                                label="Responsável"
                                value={responsavel}
                                id="responsave_"
                                onChange={e => this.setState({ responsavel: e })}
                                erro={false}
                                messageErro=''
                            />

                            <S.ContainerInput>
                                <Select
                                    marginBottom="32px"
                                    name="filial"
                                    className="select"
                                    label="Filial"
                                    id="agro_subsidiary_id"
                                    value={this.state.filial}
                                    onChange={f => this.setState({ filial: f.value, erroFilial: false })}
                                    options={this.state.filiais}
                                    disabled={false}
                                    erro={this.state.erroFilial}
                                    messageErro={this.state.erroFilialMsg}
                                    selectUniqueOption={true}
                                    labelWithAsterisk
                                />
                            </S.ContainerInput>

                            <Input
                                marginBottom="4px"
                                name="telefone"
                                type="text"
                                label="Telefone"
                                id="telefone"
                                value={telefone}
                                onChange={e => this.setState({ telefone: e })}
                            />

                            <Input
                                marginBottom="4px"
                                name="celular"
                                type="text"
                                label="Celular"
                                id="celular"
                                value={celular}
                                onChange={e => this.setState({ celular: e })}
                            />

                            <Input
                                marginBottom="4px"
                                name="cep"
                                type="text"
                                label="CEP"
                                id="cep"
                                value={cep}
                                onChange={e => this.cangeCep(e)}
                                onBlur={(e) => this.fetchCep(e.target.value)}
                                erro={this.state.erroCep}
                                messageErro={this.state.erroCepMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="endereco"
                                type="text"
                                label="Endereço"
                                id="endereco"
                                value={endereco}
                                onChange={e => this.setState({ endereco: e, erroEndereco: false })}
                                erro={this.state.erroEndereco}
                                messageErro={this.state.erroEnderecoMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="numero"
                                label="Número"
                                id="numero"
                                value={numero}
                                onChange={e => {
                                    this.setState({ numero: e, erroNumero: false })
                                }}
                                erro={this.state.erroNumero}
                                messageErro={this.state.erroNumeroMsg}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="complemento"
                                type="text"
                                label="Complemento"
                                id="complemento"
                                value={complemento}
                                onChange={e => this.setState({ complemento: e })}
                            />

                            <Input
                                marginBottom="4px"
                                name="bairro"
                                type="text"
                                label="Bairro"
                                id="bairro"
                                value={bairro}
                                onChange={e => this.setState({ bairro: e, erroBairro: false })}
                                erro={this.state.erroBairro}
                                messageErro={this.state.erroBairroMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="cidade"
                                type="text"
                                label="Cidade"
                                id="cidade"
                                value={cidade}
                                onChange={e => this.setState({ cidade: e, erroCidade: false })}
                                erro={this.state.erroCidade}
                                messageErro={this.state.erroCidadeMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <S.ContainerInput>
                                <Select
                                    marginBottom="70px"
                                    name="estado"
                                    className="select"
                                    label="Estado"
                                    id="estado_id"
                                    value={estado}
                                    onChange={state => this.setState({ estado: state.value, erroEstado: false })}
                                    options={estados}
                                    estado={true}
                                    disabled={this.state.estado.value || this.state.estado ? true : false}
                                    erro={this.state.erroEstado}
                                    messageErro={this.state.erroEstadoMsg}
                                    loading={this.state.loadingCep}
                                    labelWithAsterisk
                                />
                            </S.ContainerInput>


                            <div id="a" style={{
                                height: '0px',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: '40px',
                                marginBottom: '40px',
                            }}>
                                <Button
                                    width='100%'
                                    height='50px'
                                    value='CADASTRAR'
                                    outline={false}
                                    disabled={false}
                                    onClick={(e) => { e.preventDefault(); this.handleSubmit(e); }}
                                    loading={this.state.loading}
                                />
                            </div>
                        </form>
                    </Container>
                </DevolucaoAddContainer>
            </>
        );
    }
}

export default AddDevolucao;
